import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

export interface AppConfig {
  apiUrl: string;
  useMockApi?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private config: AppConfig | null = null;

  constructor(private http: HttpClient) {}

  async loadConfig(): Promise<void> {
    try {
      this.config = await firstValueFrom(
        this.http.get<AppConfig>('config.json')
      );
    } catch (error) {
      console.error('Failed to load config.json', error);
      // Fallback to default production config
      this.config = {
        apiUrl: 'https://apiv3.a-book.dk/1.0',
        useMockApi: false,
      };
    }
  }

  getConfig(): AppConfig {
    if (!this.config) {
      throw new Error('Config not loaded. Call loadConfig() first.');
    }
    return this.config;
  }

  getApiUrl(): string {
    console.log(this.getConfig().apiUrl);
    return this.getConfig().apiUrl;
  }

  isUsingMockApi(): boolean {
    return this.getConfig().useMockApi ?? false;
  }
}
